// extracted by mini-css-extract-plugin
export default {"wrapper":"IqosSeaSide_wrapper__JSnCg","mapContainer":"IqosSeaSide_mapContainer__5nMO6","details":"IqosSeaSide_details__vvbYv","lastContent":"IqosSeaSide_lastContent__htw2f"};